export default __webpack_public_path__ + "assets/images/apply_champion.svg";